import { defineMessages } from 'react-intl';

export const scope = 'dataset';

export default defineMessages({
    gdrive_folder_error: {
        id: `${scope}.gdrive_folder_error`,
        defaultMessage: 'Failed to load Google Drive folders.',
    },
    onedrive_folder_error: {
        id: `${scope}.onedrive_folder_error`,
        defaultMessage: 'Failed to load OneDrive folders. Please try again.',
    },
    google_token_error: {
        id: `${scope}.google_token_error`,
        defaultMessage: 'Failed to load Google token. Please try again.',
    },
    file_load_error: {
        id: `${scope}.file_load_error`,
        defaultMessage: 'Failed to load files.',
    },
    file_select_error: {
        id: `${scope}.file_select_error`,
        defaultMessage: 'Please select at least one file.',
    },
    url_add_error: {
        id: `${scope}.url_add_error`,
        defaultMessage: 'Please add at least one URL.',
    },
    gdrive_add_error: {
        id: `${scope}.gdrive_add_error`,
        defaultMessage: 'Please add a Google Drive folder.',
    },
    onedrive_add_error: {
        id: `${scope}.onedrive_add_error`,
        defaultMessage: 'Please add a OneDrive folder.',
    },
    gmail_subject_message_error: {
        id: `${scope}.gmail_subject_message_error`,
        defaultMessage: 'Please add a Gmail subject message.',
    },
    outlook_subject_message_error: {
        id: `${scope}.outlook_subject_message_error`,
        defaultMessage: 'Please add an Outlook subject message.',
    },
    appflyte_project_message_error: {
        id: `${scope}.appflyte_project_message_error`,
        defaultMessage: 'Please select at least one project.',
    },
    gdrive_token_error: {
        id: `${scope}.gdrive_token_error`,
        defaultMessage: 'Google Drive authentication tokens are missing.',
    },
    gmail_token_error: {
        id: `${scope}.gmail_token_error`,
        defaultMessage: 'Gmail authentication tokens are missing.',
    },
    onedrive_token_error: {
        id: `${scope}.onedrive_token_error`,
        defaultMessage: 'OneDrive authentication tokens are missing.',
    },
    outlook_token_error: {
        id: `${scope}.outlook_token_error`,
        defaultMessage: 'Outlook authentication tokens are missing.',
    },
    links_error: {
        id: `${scope}.links_error`,
        defaultMessage: 'No valid links found.',
    },
    file_selection_error: {
        id: `${scope}.file_selection_error`,
        defaultMessage: 'No valid files selected.',
    },
    mongo_source_error: {
        id: `${scope}.mongo_source_error`,
        defaultMessage: 'No valid MongoDB sources found.',
    },
    dataset_add_success: {
        id: `${scope}.dataset_add_success`,
        defaultMessage: 'Dataset added successfully.',
    },
    ameya_extract_error: {
        id: `${scope}.ameya_extract_error`,
        defaultMessage: 'No valid Ameya Extract sources found.',
    },
    dataset_add_error: {
        id: `${scope}.dataset_add_error`,
        defaultMessage: 'Dataset creation failed. Please try again.',
    },
    dataset_name_error: {
        id: `${scope}.dataset_name_error`,
        defaultMessage: 'Dataset name is required.',
    },
    dataset_name_check: {
        id: `${scope}.dataset_name_check`,
        defaultMessage: 'A dataset with this name already exists.',
    },
    dataset_update_success: {
        id: `${scope}.dataset_update_success`,
        defaultMessage: 'Dataset updated successfully.',
    },
    dataset_update_error: {
        id: `${scope}.dataset_update_error`,
        defaultMessage: 'Error updating dataset. Please try again.',
    },
    connection_error: {
        id: `${scope}.connection_error`,
        defaultMessage: 'Connection failed. Please try again.',
    },
    file_size_error: {
        id: `${scope}.file_size_error`,
        defaultMessage: 'File size exceed maximum limit of 40 MB.',
    },
    file_selection_warning: {
        id: `${scope}.file_selection_warning`,
        defaultMessage: 'Please select a file and try again.',
    },
    file_upload_error: {
        id: `${scope}.file_upload_error`,
        defaultMessage: 'All file uploads failed.',
    },
    file_delete_warning: {
        id: `${scope}.file_delete_warning`,
        defaultMessage: 'Are you sure you want to delete this file?',
    },
    file_delete_success: {
        id: `${scope}.file_delete_success`,
        defaultMessage: 'File deleted successfully.',
    },
    file_delete_error: {
        id: `${scope}.file_delete_error`,
        defaultMessage: 'Failed to delete file.',
    },
    source_token_error: {
        id: `${scope}.source_token_error`,
        defaultMessage: 'Your session has expired. Please reconnect to continue.',
    },
    source_error: {
        id: `${scope}.source_error`,
        defaultMessage: 'Invalid data source.',
    }
});
